import React from 'react';
import { useHistory } from 'react-router-dom';
import { appRoutes } from '../../../routes/routes';
import { Text, textVariantsEnum, fontWeightEnum } from '@/components/Text';
import { KekaCard } from './KekaCard.component';
import styles from './KekaDetailPage.module.scss';

export const KekaDetailPage = () => {
  const history = useHistory();

  return (
    <div className={styles.page}>
      <button
        className={styles.backBtn}
        onClick={() => history.push(appRoutes().integrations)}
      >
        ← Back to Integrations
      </button>

      <div className={styles.pageHeader}>
        <div className={styles.headerLeft}>
          <div className={styles.logoMark}>K</div>
          <div className={styles.titleBlock}>
            <Text
              variant={textVariantsEnum.Header}
              fontWeight={fontWeightEnum.Semibold}
            >
              Keka HR
            </Text>
            <Text
              variant={textVariantsEnum.Text_13}
              fontWeight={fontWeightEnum.Normal}
              color="gray-600"
            >
              Push Prodaff tracked hours to Keka as attendance punch records.
            </Text>
          </div>
        </div>
      </div>

      <div className={styles.panels}>
        <KekaCard />
      </div>
    </div>
  );
};
